const styles = () => ({
  root: {
    border: '1px solid #e0e0e0',
    borderRadius: 6,
    padding: 16,
    marginTop: 8,
    marginBottom: 16,
    background: '#fafafa',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  studentName: {
    fontSize: 18,
    fontWeight: 600,
  },
  studentMeta: {
    color: '#656565',
    fontSize: 13,
  },
  hoursGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 24,
    marginBottom: 16,
  },
  hoursBlock: {
    minWidth: 200,
  },
  hoursLabel: {
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 4,
  },
  hoursValue: {
    fontSize: 13,
    color: '#656565',
    marginBottom: 4,
  },
  progressBarOuter: {
    width: '100%',
    height: 10,
    borderRadius: 5,
    background: '#e0e0e0',
    overflow: 'hidden',
  },
  progressBarInner: {
    height: '100%',
    borderRadius: 5,
    background: '#68d190',
  },
  exclusionSection: {
    marginTop: 16,
    paddingTop: 12,
    borderTop: '1px solid #e0e0e0',
  },
  exclusionTitle: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 8,
  },
  exclusionMeta: {
    fontSize: 13,
    color: '#656565',
    marginBottom: 8,
  },
  exclusionControls: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: 16,
  },
  exclusionReason: {
    minWidth: 260,
  },
  exclusionNote: {
    minWidth: 220,
  },
  narrativeBlock: {
    marginBottom: 12,
  },
  narrativeField: {
    marginBottom: 8,
  },
  aepSection: {
    marginTop: 16,
    paddingTop: 12,
    borderTop: '1px solid #e0e0e0',
  },
  aepSectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 8,
  },
  aepControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  aepStatus: {
    fontSize: 13,
    color: '#656565',
  },
  aepError: {
    fontSize: 13,
    color: '#d32f2f',
  },
  downloadLink: {
    marginLeft: 12,
  },
});

export default styles;
